import { render } from "./seleccion-producto-stock-component.vue?vue&type=template&id=3278805c&scoped=true"
import script from "./seleccion-producto-stock-component.vue?vue&type=script&lang=js"
export * from "./seleccion-producto-stock-component.vue?vue&type=script&lang=js"

import "./seleccion-producto-stock-component.vue?vue&type=style&index=0&id=3278805c&scoped=true&lang=scss"

import exportComponent from "C:\\GIT CLONADO\\ubiku.2023\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3278805c"]])

export default __exports__